import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SummerCampLayout from './components/Layout/SummerCampLayout';
import SummerCampLanding from './components/pages/SummerCampLanding';
import './App.css';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  return (
    <Router>
      <Routes>
        {/* Main Layout Wrapper */}
        <Route element={<SummerCampLayout onRegisterClick={toggleModal} />}>
          {/* Index Route for the Landing Page */}
          <Route path="/" element={
            <SummerCampLanding 
              isModalOpen={isModalOpen} 
              toggleModal={toggleModal} 
            />
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;